import sentGAEvent from ".";

/**
 * 注册页面出现曝光埋点
 */
const GASignUpPageDisplay = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_up_display",
  });
};

/**
 * 点击注册按钮
 */
const GASignUpClickConfirm = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_confirm_click",
  });
};

/**
 * 注册表单格式报错
 * @param {string} label
 */
const GASignUpFromError = label => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_up_error",
    label,
  });
};

/**
 * 注册页面跳转login页面
 */
const GASignUpClickToLogin = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_to_login_click",
  });
};

/**
 * 注册页面跳转service页面
 */
const GASignUpClickToService = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_services_click",
  });
};

/**
 * 注册页面跳转privacy页面
 */
const GASignUpClickToPrivacy = () => {
  sentGAEvent({
    category: "sign_up",
    action: "sign_privacy_click",
  });
};

/**
 *注册页面问卷1上报
 * @param {string} label
 */
const GASignUpQuestionnaireFirst = label => {
  sentGAEvent({
    category: "questionnaire",
    action: "questionnaire_purpose",
    label,
  });
};

/**
 *注册页面问卷2上报
 * @param {string} label
 */
const GASignUpQuestionnaireSeconds = label => {
  sentGAEvent({
    category: "questionnaire",
    action: "questionnaire_video_content",
    label,
  });
};

/**
 *注册页面问卷主题选择上报
 * @param {string} label
 */
const GASignUpQuestionnaireTheme = label => {
  sentGAEvent({
    category: "questionnaire",
    action: "questionnaire_display",
    label,
  });
};

/**
 * 注册成功弹窗点击OK按钮
 */
const GASignUpQuestionnaireClickOK = () => {
  sentGAEvent({
    category: "questionnaire",
    action: "sign_success",
  });
};

export {
  GASignUpPageDisplay,
  GASignUpClickConfirm,
  GASignUpFromError,
  GASignUpClickToLogin,
  GASignUpClickToService,
  GASignUpClickToPrivacy,
  GASignUpQuestionnaireFirst,
  GASignUpQuestionnaireSeconds,
  GASignUpQuestionnaireTheme,
  GASignUpQuestionnaireClickOK,
};
